import { render, staticRenderFns } from "./DecisionOnLeaveToAppealAppApplyLeavePg.vue?vue&type=template&id=28e1b1dc&scoped=true"
import script from "./DecisionOnLeaveToAppealAppApplyLeavePg.vue?vue&type=script&lang=ts"
export * from "./DecisionOnLeaveToAppealAppApplyLeavePg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e1b1dc",
  null
  
)

export default component.exports